import { useEffect, useState } from "react";
import { createUser} from "../../services/AllServices";
import {showMessage } from "../../utils/helpers";
import {  useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { CreateUserValidation } from "../../pages/UserManagement/Validations";

const useUserManagementCreateViewController = () => {
    
    const [generatedPassword, setGeneratedPassword] = useState("");
  const [generatedUsername, setGeneratedUsername] = useState("");
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const { setFieldValue, handleSubmit, handleChange, errors, values, touched } =
    useFormik({
      initialValues: {
        name: "",
        role: "",
        email:"",
      },
      validationSchema: CreateUserValidation,

      onSubmit: async (values) => {
        setLoading(true);
        try {
          const responseData = await createUser(values);
          setGeneratedPassword(responseData?.password);
          setGeneratedUsername(responseData?.username);
          setShowModal(true);
        } catch (error) {
          showMessage("error", error?.response?.data?.message || "Something went wrong");
        }
        setLoading(false);
      },
    });
  const handleSelectedEmployee = (e) => {
    setFieldValue("role", e?.value);
  };

  const goBack = () => {
    navigate("/user-management");
  };

  useEffect(() => {
    setFieldValue("password", generatedPassword);
    setFieldValue("name", generatedUsername);
  }, [generatedPassword, generatedUsername, setFieldValue]);


    return {
        goBack,
        values,
        touched,
        errors,
        handleChange,
        handleSelectedEmployee,
        handleSubmit,
        showModal,
        setShowModal,
        generatedUsername,
        generatedPassword,   
        loading
    }
}
export default useUserManagementCreateViewController;